import { Navigate } from 'react-router-dom';
import AmicaleLayout from '../components/AmicaleLayout';
import MoteurAmicalesPage from '../pages/MoteurAmicalesPage';
import EspaceAmicalesPage from '../pages/EspaceAmicalesPage';

export const AMICALE_PATHS = {
  ROOT: '/',
  ESPACE: '/espace-amicales',
};

export const amicaleRoutesConfig = [
  {
    element: <AmicaleLayout />,
    children: [
      { index: true, element: <MoteurAmicalesPage /> },
      { path: 'espace-amicales', element: <EspaceAmicalesPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
];
